/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Dispatch, SetStateAction, useState, useRef, useEffect } from 'react';
import { ICustomerData, ISuitcaseServiceData } from 'src/environments/Checkout/interfaces';
import QRCode from 'react-qr-code';
import Swal from 'sweetalert2';
import { apiCheckout } from 'src/environments/Checkout/api';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ButtonModifyMethod,
  ContainerIconMethod,
  ContainerMethodSelected,
  ContainerPix,
  ContainerQrCode,
  CopyIcon,
  IconPix,
  LoadingGif,
  PixButtonContainer,
  PixButtonCopy,
} from './style';

import pixWhiteSVG from '../../../../../../../../assets/images/outfits-montage-icons/pix-white.svg';
import copyIconSVG from '../../../../../../../../assets/images/outfits-montage-icons/copy-icon.svg';
import loadingGIF from '../../../../../../../../assets/gifs/loading.png';
import Cronometer from './Components';

type Props = {
  customerData: ICustomerData;
  serviceData: ISuitcaseServiceData;
  platform: string;
  setShowPaymentMethod: Dispatch<SetStateAction<string>>;
};

export default function PurchasePaymentPix({
  customerData,
  serviceData,
  platform,
  setShowPaymentMethod,
}: Props): JSX.Element {
  const [qrCode, setQrCode] = useState({ QR_CODE: '', transactionId: '' });
  const [loading, setLoading] = useState(true);
  const [copy, setCopy] = useState(false);
  const [intervalId, setIntervalId] = useState<NodeJS.Timer>();

  const { token } = useParams();

  const navigate = useNavigate();

  const getPixPaymentInfo = (transactionId: string): void => {
    const interval = setInterval(async () => {
      const { transactionPaid } = await apiCheckout.checkSuitcasePaymentStatus(
        transactionId,
        token
      );

      if (transactionPaid) {
        clearInterval(interval);
        void Swal.fire({
          icon: 'success',
          title: 'Pagamento realizado com sucesso!',
          text: `Serviço ${serviceData.serviceName}`,
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
        window.location.href =
          'https://www.resolvaconsultoria.com/app-resolva/club.html?initialTab=Compras&purchaseStatus=Pendentes';
        navigate(`/pagamento-concluido/${platform}/${serviceData.serviceName}`);
      }
    }, 5000);
    setIntervalId(interval);
  };

  const getQrCode = async (): Promise<void> => {
    try {
      setLoading(true);
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);

      const serviceMontageData = {
        ...customerData,
        customerPhone: customerData.customerPhone.replace(/[^a-zA-Z0-9]/g, '').replace(' ', ''),
        customerCpf: customerData.customerCpf.replace(/[^a-zA-Z0-9]/g, ''),
        zipCode: customerData.zipCode.replace('-', ''),
        consultantName:
          customerData.consultantId && customerData.consultantId !== 0
            ? customerData.consultantName
            : 'Resolva meu look',
        consultantId:
          customerData.consultantId && customerData.consultantId !== 0
            ? customerData.consultantId
            : 0,
        serviceName: serviceData.serviceName,
        serviceValue: serviceData.pixPrice / 100,
        installments: 1,
        amount: serviceData.pixPrice,
        paymentMethod: 'Pix',
        paymentStatus: 'Aguardando',
        platform,
        numberOfDays: serviceData.numberOfDays,
      };

      const data = await apiCheckout.createSuitcasePixOrder(serviceMontageData, token);

      setQrCode(data);
      if (data.transactionId) {
        getPixPaymentInfo(data.transactionId);
      }
      setLoading(false);
    } catch (e) {
      void Swal.fire({
        icon: 'error',
        title: 'Erro na geração do pix!',
        text: 'Por favor, faça o pagamento por cartão de crédito',
        iconColor: 'black',
        confirmButtonColor: 'black',
      });
      setShowPaymentMethod('');
    }
  };

  const shouldLog = useRef(true);

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      void getQrCode();
    }
  }, []);

  const handleClickCopy = (): void => {
    void navigator.clipboard.writeText(qrCode.QR_CODE);
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 3000);
  };

  return (
    <ContainerPix>
      <ContainerMethodSelected>
        <ContainerIconMethod>
          <IconPix src={pixWhiteSVG} alt="Ícone do pix branco" />
          <p>PIX</p>
        </ContainerIconMethod>
        <ButtonModifyMethod
          onClick={() => {
            setShowPaymentMethod('');
            clearInterval(intervalId);
          }}
        >
          Modificar
        </ButtonModifyMethod>
      </ContainerMethodSelected>
      {loading ? (
        <LoadingGif src={loadingGIF} alt="Loading spinning" />
      ) : (
        <>
          {qrCode.QR_CODE !== '' && (
            <PixButtonContainer>
              <p>
                Clique no código abaixo e utilize o Pix Copia e Cola no aplicativo que você vai
                fazer o pagamento:
              </p>
              <PixButtonCopy onClick={handleClickCopy}>
                {copy ? (
                  <span>Copiado!</span>
                ) : (
                  <>
                    {qrCode.QR_CODE.slice(0, 35)}...
                    <CopyIcon src={copyIconSVG} alt="copiar e colar" />
                  </>
                )}
              </PixButtonCopy>
              <ContainerQrCode>
                <Cronometer intervalId={intervalId} setShowPaymentMethod={setShowPaymentMethod} />
                <QRCode value={qrCode.QR_CODE} />
              </ContainerQrCode>
            </PixButtonContainer>
          )}
        </>
      )}
    </ContainerPix>
  );
}
